export default __webpack_public_path__ + "static/media/pro_aim_app.ac53489a.png";